import { render, staticRenderFns } from "./WarehouseMovements.vue?vue&type=template&id=160140fc&scoped=true&"
import script from "./WarehouseMovements.vue?vue&type=script&lang=js&"
export * from "./WarehouseMovements.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseMovements.vue?vue&type=style&index=0&id=160140fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160140fc",
  null
  
)

export default component.exports